export const FACILITY_TYPE_LABELS: Record<string, string> = {
	production_plant: 'Linia produkcyjna',
}

export const FACILITY_CAPABILITY_LABELS: Record<string, string> = {
	production: 'Produkcja',
	confection: 'Konfekcja',
	completion: 'Kompletacja',
	customer_shipping: 'Wysyłka do klienta',
}

export const getFacilityTypeLabel = (type: string): string => FACILITY_TYPE_LABELS[type] ?? type

export const getFacilityCapabilityLabel = (capability: string): string =>
	FACILITY_CAPABILITY_LABELS[capability] ?? capability

export const FACILITY_TYPE_OPTIONS: IMultiSelectTypeOptions<string> = Object.entries(FACILITY_TYPE_LABELS).map(
	([value, label]) => ({ value, label }),
)

export const FACILITY_CAPABILITY_OPTIONS: IMultiSelectTypeOptions<string> = Object.entries(
	FACILITY_CAPABILITY_LABELS,
).map(([value, label]) => ({ value, label }))
